import React, {useEffect, useState} from 'react';
import {Button, Text, TextTypography} from '@wix/wix-ui-tpa/cssVars';
import {useLocaleKeys} from '../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../Widget/ControllerContext';
import {classes} from './ErrorDialog.st.css';
import {Action} from '../../../domain/models/checkout/Errors/ModalError.model';
import {BiErrorDialogAction} from '../../../domain/utils/bi.util';
import {EcomDialog} from '../../../common/components/EcomDialog/EcomDialog';

export enum ErrorDialogDataHooks {
  Root = 'ErrorDialogDataHooks.Root',
  Title = 'ErrorDialogDataHooks.Title',
  Description = 'ErrorDialogDataHooks.Description',
  Button = 'ErrorDialogDataHooks.Button',
}

export const ErrorDialog = () => {
  const {
    checkoutStore: {
      onErrorDialogOpened,
      onErrorDialogClosed,
      reportCheckoutCartClickOnCtaInErrorDialog,
      cart,
      modalError,
    },
    navigationStore: {clickOnBackToSite, clickOnReturnToCart},
  } = useControllerProps();
  const localeKeys = useLocaleKeys();
  const [error] = useState(cart.noItemsError || modalError);
  const [isDialogOpen, setIsDialogOpen] = useState(true);

  useEffect(() => {
    onErrorDialogOpened(error);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleDialogOnClose = () => {
    onErrorDialogClosed();
    setIsDialogOpen(false);
  };

  const onClose = () => {
    reportCheckoutCartClickOnCtaInErrorDialog({
      errorCode: error!.biCode,
      actionName: BiErrorDialogAction.clickOnX,
    });
    handleDialogOnClose();
  };

  const handleClickOnReturnToCart = () => {
    void clickOnReturnToCart();
  };

  const onClick = () => {
    reportCheckoutCartClickOnCtaInErrorDialog({
      errorCode: error!.biCode,
      actionName: BiErrorDialogAction.clickOnCta,
    });
    if (error!.action === Action.BackToSite) {
      return clickOnBackToSite();
    }
    if (error!.action === Action.ReturnToCart) {
      if (!cart.currentCart) {
        return clickOnBackToSite();
      }
      return handleClickOnReturnToCart();
    }
    return handleDialogOnClose();
  };

  const getButtonText = () => {
    if (error!.action === Action.BackToSite) {
      return localeKeys.cart.validation.error.EMPTY_CART.button();
    }
    if (error!.action === Action.ReturnToCart) {
      if (!cart.currentCart) {
        return localeKeys.cart.validation.error.EMPTY_CART.button();
      }
      return localeKeys.checkout.informative_modal.return_to_cart();
    }
    if (error!.action === Action.GotIt) {
      return localeKeys.checkout.page.technicalCalculationError.cta();
    }
    if (error!.action === Action.BackToPreview) {
      return localeKeys.checkout.previewModal.expressCheckout.cta();
    }
    return localeKeys.checkout.orderFailedModal.returnToCheckout.button();
  };

  return (
    <EcomDialog data-hook={ErrorDialogDataHooks.Root} isOpen={isDialogOpen} onClose={onClose}>
      <div className={classes.root}>
        <div className={classes.content}>
          <Text data-hook={ErrorDialogDataHooks.Title} typography={TextTypography.largeTitle}>
            {error!.title}
          </Text>
          <Text data-hook={ErrorDialogDataHooks.Description} typography={TextTypography.runningText}>
            {error!.description}
          </Text>
        </div>
        <Button data-hook={ErrorDialogDataHooks.Button} className={classes.button} onClick={() => onClick()} upgrade>
          {getButtonText()}
        </Button>
      </div>
    </EcomDialog>
  );
};
